import React from 'react';
import { Layout } from '../components/Layout';
import { ProtocolCard } from '../components/ProtocolCard';
import { Section } from '../components/ui/Section';
import { Container } from '../components/ui/Container';
import { SEO } from '../components/SEO';
import { PILLARS } from '../utils/constants';
import { useLanguage } from '../contexts/LanguageContext';
export function PersonalProtocol() {
  const {
    t
  } = useLanguage();
  return <Layout data-id="element-4804">
      <SEO title="Personal Security Protocol | CyberSecurityProtocol" description="A practical personal security protocol covering accounts, devices, data protection, and online safety to reduce common cyber risks." keywords="personal security, personal cybersecurity, account security, device security, data protection, online safety, personal cyber protocol" url="https://cybersecurityprotocol.org/personal" data-id="element-4805" />

      <Section spacing="lg" data-id="element-4806">
        <Container size="lg" data-id="element-4807">
          {/* Header - Mobile Optimized */}
          <div className="mb-12 sm:mb-16 px-4" data-id="element-4808">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-slate-100 mb-3 sm:mb-4" data-id="element-4809">
              {t('personal.title')}
            </h1>
            <p className="text-slate-400 max-w-2xl text-base sm:text-lg" data-id="element-4810">
              {t('personal.subtitle')}
            </p>
          </div>

          {/* Protocol Cards Grid - Mobile Optimized */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-4811">
            {PILLARS.map(pillar => <ProtocolCard key={pillar.id} {...pillar} data-id="element-4812" />)}
          </div>
        </Container>
      </Section>
    </Layout>;
}